import { type CopilotPageContext } from './types'

/**
 * Page context payload exposed to the agent.
 *
 * Strips UI-only fields (e.g. suggested prompts) and per-element `inspectDetails`
 * so large inspect payloads are only returned via `inspect_current_page`.
 */
export const toCopilotAgentPageContext = (pageContext: CopilotPageContext): CopilotPageContext => {
  const { suggestedPrompts: _suggestedPrompts, elements, ...rest } = pageContext

  return {
    ...rest,
    elements: elements?.map(({ inspectDetails: _inspectDetails, ...element }) => element)
  }
}
